import React from "react";
import useStore from "../../store";
import { PTMDialog } from "../../Components";

export default function Privacy() {
    const currentDialog = useStore((store) => store.dashboard.dialogs.currentOpenDialog);
    const setDialog = useStore((store) => store.dashboard.dialogs.setCurrentOpenDialog);

    return (
        <PTMDialog
            title="Datenschutz"
            open={currentDialog === "privacy"}
            onClose={() => setDialog("")}
            everywhereVisible
            fixedWidth={600}
        >
            <h5>
                Vorwort
            </h5>
            <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                <p />
                Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
                <p />
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
            </p>
            <h5>
                Datenübermittlung /Datenprotokollierung
            </h5>
            <p>
                Beim Besuch dieser Seite verzeichnet der Web-Server automatisch Log-Files, die keiner bestimmten Person zugeordnet werden können. Diese Daten beinhalten, den Browsertyp und -version, verwendetes Betriebssystem, IP-Adresse des anfragenden Rechners, Zugriffsdatum und -uhrzeit der Serveranfrage und die Dateianfrage des Client (Dateiname und URL). Diese Daten werden nur zum Zweck der statistischen Auswertung gesammelt. Eine Weitergabe an Dritte, zu kommerziellen oder nichtkommerziellen Zwecken, findet nicht statt.
            </p>
            <h5>
                Nutzung personenbezogener Daten
            </h5>
            <p>
                Personenbezogene Daten werden nur erhoben oder verarbeitet, wenn Sie diese Angaben freiwillig, z.B. im Rahmen einer Anfrage mitteilen. Sofern keine erforderlichen Gründe im Zusammenhang mit einer Geschäftsabwicklung bestehen, können Sie jederzeit die zuvor erteilte Genehmigung Ihrer persönlichen Datenspeicherung mit sofortiger Wirkung schriftlich (z.B. per E-Mail) bei uns widerrufen. Ihre Daten werden nicht an Dritte weitergeben, es sei denn, eine Weitergabe ist aufgrund gesetzlicher Vorschriften erforderlich.
            </p>

            <h5>
                Weitergabe personenbezogener Daten
            </h5>
            <p>
                Ohne Ihre ausdrückliche Einwilligung geben wir Ihre Daten nicht an Dritte weiter. Ausgenommen hiervon sind lediglich unsere Dienstleistungspartner, mit denen wir zur Abwicklung des Vertragsverhältnisses zusammenarbeiten. Dabei halten wir uns selbstverständlich an die Vorgaben des Bundesdatenschutzgesetzes und übermitteln nur ein Mindestmaß an Daten.
            </p>

            <h5>
                Cookies
            </h5>
            <p>
                Unsere Internetseiten verwenden an mehreren Stellen so genannte Cookies. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert. Sie dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Des Weiteren ermöglichen Cookies unseren Systemen, Ihren Browser zu erkennen und Ihnen Services anzubieten. Cookies enthalten keine personenbezogenen Daten.
            </p>
            <h5>
                SSL- bzw. TLS-Verschlüsselung
            </h5>
            <p>
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von &quot;http://&quot; auf &quot;https://&quot; wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                <p />
                Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
            </p>
            <h5>
                Datenschutzbeauftragter
            </h5>
            <p>
                Wir haben für unser Unternehmen einen Datenschutzbeauftragten bestellt.
                <br />
                {" "}
                <br />
                {" "}
                Andreas Huhle
                <br />
                {" "}
                Porthun & Thiede Systemhaus GmbH & Co. KG
                <br />
                {" "}
                Wismarsche Straße 323a
                <br />
                {" "}
                19055 Schwerin
                <br />
                {" "}
                <br />
                {" "}
                Telefon: 0385 5958690
                <br />
                {" "}
                Fax: 0385 5958699
                <br />
                {" "}
                E-Mail:
                <a href="info@pt-systemhaus.de">info@pt-systemhaus.de</a>
            </p>
        </PTMDialog>
    );
}
